export default {"src":"https://cdn.jetlend.ru/_next/static/media/department-borrower.0bac0a23.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};